var React = require('react');

function Union (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.2292 0C4.1335 0 0 3.5453 0 7.9186v22.1412a9.234 9.234 0 0 0 4.9209 8.1649l22.6607 11.9585c1.4826.7835 3.3542.7835 4.8368 0L55.079 38.2247A9.234 9.234 0 0 0 60 30.0598V7.9186C60 3.5453 55.8665 0 50.7708 0H9.2292z","stroke":"none","fill":"#78c62a"}));
}

Union.defaultProps = {"viewBox":"0 0 60 51","width":"60","height":"51","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","fill":"#fff","fillRule":"evenodd"};

module.exports = Union;

Union.default = Union;
